export enum ReportPrintFormat
{
    A3 = 1,
    A4 = 2
}